<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="middle"
  [closable]="false" [(visible)]="showDialog"
>
  <ng-template pTemplate="header">
    <h4>
      {{
        'communications.mass-comm-message-edit.analytics.resend.dialog.title'
          | translate : { resendOptionSelected: menuItemResendToOptionSelected?.label }
      }}
    </h4>
  </ng-template>

  <div   class="mb-27 mct-flex mct-row mct-justify-between mct-items-stretch">
    <div class="col-sm-12 text-left-xs">
      <label class="light-text">{{
        'communications.mass-comm-message-edit.analytics.resend.dialog.when-send-email-question' | translate
      }}</label>
    </div>
  </div>
  <div *ngIf="menuItemResendToOptionSelected">
    <div  class="mb-27 mct-flex mct-row mct-gap-10">
      <p-radioButton
        name="resendMode"
        [value]="scheduleModes[0].mode"
        [(ngModel)]="selectedScheduleMode"
        inputId="resendModeSendNow"
        (ngModelChange)="setSendButtonText()"
      >
      </p-radioButton>
      <label for="resendModeSendNow">
        {{ 'communications.mass-comm-message-edit.analytics.resend.dialog.radio-send-now' | translate }}
      </label>
    </div>
    <div  class="mb-27 mct-gap-10 mct-flex mct-row">
      <p-radioButton
        name="resendMode"
        [value]="scheduleModes[1].mode"
        [(ngModel)]="selectedScheduleMode"
        inputId="resendModeSendLater"
        (ngModelChange)="setSendButtonText()"
      >
      </p-radioButton>
      <label for="resendModeSendLater">
        {{ 'communications.mass-comm-message-edit.analytics.resend.dialog.radio-send-later' | translate }}
      </label>
      &nbsp;
      <wl-date-selector
        [minDate]="sendLaterDate"
        [(ngModel)]="sendLaterDate"
        [hidden]="selectedScheduleMode !== scheduleModes[1].mode"
      ></wl-date-selector>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="close()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button
        class="atlas-btn atlas-btn-primary"
        (click)="send()"
        [hidden]="selectedScheduleMode !== scheduleModes[0].mode && selectedScheduleMode !== scheduleModes[1].mode"
      >
        <wl-busy [show]="isSaving"></wl-busy>
        <span [hidden]="isSaving">{{ sendButtonText }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
